import React, { useState } from 'react';
import { MessageCircle, Clock, Plus, Settings, Trash2, Edit, Copy, Check, X, Save, Zap, ArrowRight, Heart, Image, Video, Gift, DollarSign, Sparkles } from 'lucide-react';
export function AutoReplySection() {
  const [activePersonality, setActivePersonality] = useState('girlfriend');
  const [activeTab, setActiveTab] = useState('auto-replies');
  const [editingReply, setEditingReply] = useState<string | null>(null);
  // Sample data for auto-replies
  const personalities = [{
    id: 'girlfriend',
    name: 'Girlfriend',
    emoji: '💕',
    color: 'pink'
  }, {
    id: 'mistress',
    name: 'Mistress',
    emoji: '🖤',
    color: 'purple'
  }, {
    id: 'innocent',
    name: 'Innocent Tease',
    emoji: '😇',
    color: 'blue'
  }, {
    id: 'cosplay',
    name: 'Cosplay Princess',
    emoji: '👑',
    color: 'green'
  }, {
    id: 'custom',
    name: 'Custom',
    emoji: '✨',
    color: 'orange'
  }];
  const autoReplies = [{
    id: '1',
    trigger: 'User sends "hi" or "hello"',
    response: "Hey there! 💕 I was just thinking about you. How's your day going? I just posted some new pics you might like...",
    personality: 'girlfriend',
    enabled: true,
    hasUpsell: true
  }, {
    id: '2',
    trigger: 'User sends a compliment',
    response: "Aww thank you! 🥰 You always know how to make me smile. Want to see what I'm wearing right now? I think you'd really like it...",
    personality: 'girlfriend',
    enabled: true,
    hasUpsell: true
  }, {
    id: '3',
    trigger: 'User sends a dick pic',
    response: "Mmm that looks so good 🔥 I'd love to show you what it does to me... check your DMs in a minute for a special surprise just for you.",
    personality: 'girlfriend',
    enabled: true,
    hasUpsell: true
  }, {
    id: '4',
    trigger: "User asks what you're doing",
    response: 'Just finished a hot shower and trying on some new lingerie I got yesterday... want a peek? 😘',
    personality: 'girlfriend',
    enabled: true,
    hasUpsell: true
  }, {
    id: '5',
    trigger: 'User sends "hi" or "hello"',
    response: 'Well, well... look who decided to message Me. 😏 Did I give you permission to speak? Perhaps you need to earn My attention first...',
    personality: 'mistress',
    enabled: true,
    hasUpsell: false
  }, {
    id: '6',
    trigger: "User asks what you're doing",
    response: "I'm preparing some new rules for My good boys. Are you worthy of seeing them? Prove it by subscribing to My premium content first.",
    personality: 'mistress',
    enabled: true,
    hasUpsell: true
  }, {
    id: '7',
    trigger: 'User sends "hi" or "hello"',
    response: "Oh! Hi there! *blushes* I'm so happy you messaged me! I was just thinking about trying something new today... but it's kind of naughty 🙈",
    personality: 'innocent',
    enabled: true,
    hasUpsell: true
  }, {
    id: '8',
    trigger: 'User sends "hi" or "hello"',
    response: 'Greetings, loyal subject! Your princess demands tribute! 👑 *giggles* Just kidding! But I do have a special royal photoshoot to share with my VIPs!',
    personality: 'cosplay',
    enabled: true,
    hasUpsell: true
  }];
  const teaseTemplates = [{
    id: '1',
    title: 'Morning Tease',
    content: 'Good morning! Just woke up and feeling a bit... naughty 🙈 Want to see what I sleep in? Check out my latest post!',
    personality: 'girlfriend',
    conversionRate: '48%'
  }, {
    id: '2',
    title: 'New Lingerie Tease',
    content: "Just got some new lingerie and can't wait to show it off... but only my VIP fans get to see the full set 😘 Wanna join them?",
    personality: 'girlfriend',
    conversionRate: '62%'
  }, {
    id: '3',
    title: 'Shower Tease',
    content: 'About to hop in the shower... wish you could join me 💦 My VIP fans get to see what happens next...',
    personality: 'girlfriend',
    conversionRate: '58%'
  }, {
    id: '4',
    title: 'Obedience Test',
    content: 'I have a new obedience test for worthy slaves. Only the most dedicated will pass and receive their reward. Are you up for the challenge?',
    personality: 'mistress',
    conversionRate: '45%'
  }, {
    id: '5',
    title: 'First Time Confession',
    content: "I've never told anyone this before... but I've been having these thoughts lately *blushes* Should I tell you more? 🙈",
    personality: 'innocent',
    conversionRate: '52%'
  }, {
    id: '6',
    title: 'Cosplay Preview',
    content: "Getting into character for my newest cosplay! Can you guess who I'm dressed as? 👑 Full photoset available for my royal court members!",
    personality: 'cosplay',
    conversionRate: '56%'
  }];
  const filteredReplies = autoReplies.filter(reply => activePersonality === 'all' || reply.personality === activePersonality);
  const filteredTemplates = teaseTemplates.filter(template => activePersonality === 'all' || template.personality === activePersonality);
  const getPersonalityColor = (personality: string) => {
    const found = personalities.find(p => p.id === personality);
    return found ? found.color : 'gray';
  };
  return <div className="space-y-6" data-id="element-3705">
      {/* Personality Mood Selector */}
      <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3706">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2" data-id="element-3707">
          <MessageCircle className="w-5 h-5 text-purple-500" data-id="element-3708" />
          Auto-Reply Personality
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-3" data-id="element-3709">
          {personalities.map(personality => <button key={personality.id} className={`p-4 rounded-lg flex flex-col items-center justify-center gap-2 transition-colors ${activePersonality === personality.id ? `bg-${personality.color}-100 dark:bg-${personality.color}-900/30 border-2 border-${personality.color}-500` : 'bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800'}`} onClick={() => setActivePersonality(personality.id)} data-id="element-3710">
              <span className="text-3xl" data-id="element-3711">{personality.emoji}</span>
              <span className={`font-medium ${activePersonality === personality.id ? `text-${personality.color}-600 dark:text-${personality.color}-400` : ''}`} data-id="element-3712">
                {personality.name}
              </span>
            </button>)}
        </div>
        <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800/30" data-id="element-3713">
          <div className="flex items-start gap-3" data-id="element-3714">
            <div className="p-2 bg-blue-100 dark:bg-blue-800/30 rounded-full flex-shrink-0" data-id="element-3715">
              <Zap className="w-5 h-5 text-blue-600 dark:text-blue-400" data-id="element-3716" />
            </div>
            <div data-id="element-3717">
              <h4 className="font-medium text-blue-800 dark:text-blue-300" data-id="element-3718">
                Pro Tip
              </h4>
              <p className="text-sm text-blue-700 dark:text-blue-400" data-id="element-3719">
                Switching personalities can increase engagement by up to 35%.
                Try changing your mood every few days to keep fans interested!
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Tabs for Auto-Replies and Tease Generator */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden" data-id="element-3720">
        <div className="flex border-b border-gray-200 dark:border-gray-700" data-id="element-3721">
          <button className={`flex-1 py-3 text-center font-medium text-sm relative ${activeTab === 'auto-replies' ? 'text-purple-600 dark:text-purple-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => setActiveTab('auto-replies')} data-id="element-3722">
            Auto-Replies
            {activeTab === 'auto-replies' && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-purple-600 dark:bg-purple-400" data-id="element-3723"></div>}
          </button>
          <button className={`flex-1 py-3 text-center font-medium text-sm relative ${activeTab === 'tease-generator' ? 'text-purple-600 dark:text-purple-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => setActiveTab('tease-generator')} data-id="element-3724">
            AI Tease Generator
            {activeTab === 'tease-generator' && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-purple-600 dark:bg-purple-400" data-id="element-3725"></div>}
          </button>
        </div>
        <div className="p-4" data-id="element-3726">
          {activeTab === 'auto-replies' ? <div className="space-y-4" data-id="element-3727">
              <div className="flex justify-between items-center" data-id="element-3728">
                <h4 className="font-medium" data-id="element-3729">
                  {activePersonality === 'all' ? 'All Auto-Replies' : `${personalities.find(p => p.id === activePersonality)?.name} Auto-Replies`}
                </h4>
                <button className="px-3 py-1.5 bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-md text-sm font-medium flex items-center gap-1" data-id="element-3730">
                  <Plus className="w-4 h-4" data-id="element-3731" />
                  Add New Reply
                </button>
              </div>
              <div className="space-y-3" data-id="element-3732">
                {filteredReplies.map(reply => <div key={reply.id} className={`p-3 rounded-lg border ${editingReply === reply.id ? 'border-purple-300 dark:border-purple-700 bg-purple-50 dark:bg-purple-900/20' : 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900'}`} data-id="element-3733">
                    {editingReply === reply.id ? <div className="space-y-3" data-id="element-3734">
                        <div data-id="element-3735">
                          <label className="block text-xs font-medium mb-1" data-id="element-3736">
                            Trigger
                          </label>
                          <input type="text" defaultValue={reply.trigger} className="w-full p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md text-sm" data-id="element-3737" />
                        </div>
                        <div data-id="element-3738">
                          <label className="block text-xs font-medium mb-1" data-id="element-3739">
                            Response
                          </label>
                          <textarea defaultValue={reply.response} rows={3} className="w-full p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md text-sm" data-id="element-3740" />
                        </div>
                        <div className="flex justify-end gap-2" data-id="element-3741">
                          <button className="px-3 py-1 bg-gray-100 dark:bg-gray-800 rounded-md text-xs font-medium" onClick={() => setEditingReply(null)} data-id="element-3742">
                            Cancel
                          </button>
                          <button className="px-3 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-md text-xs font-medium flex items-center gap-1" onClick={() => setEditingReply(null)} data-id="element-3743">
                            <Save className="w-3 h-3" data-id="element-3744" />
                            Save
                          </button>
                        </div>
                      </div> : <>
                        <div className="flex justify-between items-start mb-2" data-id="element-3745">
                          <div className="flex items-center gap-2" data-id="element-3746">
                            <div className={`w-2 h-2 rounded-full bg-${reply.enabled ? 'green' : 'gray'}-500`} data-id="element-3747"></div>
                            <h5 className="font-medium text-sm" data-id="element-3748">
                              {reply.trigger}
                            </h5>
                          </div>
                          <div className="flex items-center gap-1" data-id="element-3749">
                            <button className="p-1 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-md" onClick={() => setEditingReply(reply.id)} data-id="element-3750">
                              <Edit className="w-4 h-4 text-gray-500" data-id="element-3751" />
                            </button>
                            <button className="p-1 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-md" data-id="element-3752">
                              <Copy className="w-4 h-4 text-gray-500" data-id="element-3753" />
                            </button>
                            <button className="p-1 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-md" data-id="element-3754">
                              <Trash2 className="w-4 h-4 text-gray-500" data-id="element-3755" />
                            </button>
                          </div>
                        </div>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-3756">
                          "{reply.response}"
                        </p>
                        <div className="flex justify-between items-center" data-id="element-3757">
                          <div className="flex items-center gap-1" data-id="element-3758">
                            <span className={`w-4 h-4 rounded-full bg-${getPersonalityColor(reply.personality)}-100 dark:bg-${getPersonalityColor(reply.personality)}-900/30 flex items-center justify-center text-${getPersonalityColor(reply.personality)}-600 dark:text-${getPersonalityColor(reply.personality)}-400 text-xs`} data-id="element-3759">
                              {personalities.find(p => p.id === reply.personality)?.emoji}
                            </span>
                            <span className="text-xs text-gray-500 capitalize" data-id="element-3760">
                              {reply.personality} mode
                            </span>
                          </div>
                          {reply.hasUpsell && <span className="text-xs px-2 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-full flex items-center gap-1" data-id="element-3761">
                              <DollarSign className="w-3 h-3" data-id="element-3762" />
                              Has upsell
                            </span>}
                        </div>
                      </>}
                  </div>)}
              </div>
              <div className="flex justify-center" data-id="element-3763">
                <button className="px-4 py-2 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg text-sm font-medium transition-colors" data-id="element-3764">
                  Load More
                </button>
              </div>
            </div> : <div className="space-y-4" data-id="element-3765">
              <div className="flex justify-between items-center" data-id="element-3766">
                <h4 className="font-medium" data-id="element-3767">
                  {activePersonality === 'all' ? 'All Tease Templates' : `${personalities.find(p => p.id === activePersonality)?.name} Tease Templates`}
                </h4>
                <button className="px-3 py-1.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-md text-sm font-medium flex items-center gap-1" data-id="element-3768">
                  <Sparkles className="w-4 h-4" data-id="element-3769" />
                  Generate New Tease
                </button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-3770">
                {filteredTemplates.map(template => <div key={template.id} className="p-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900" data-id="element-3771">
                    <div className="flex justify-between items-start mb-2" data-id="element-3772">
                      <h5 className="font-medium text-sm" data-id="element-3773">{template.title}</h5>
                      <span className="text-xs px-2 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-full" data-id="element-3774">
                        {template.conversionRate} conversion
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-3" data-id="element-3775">
                      "{template.content}"
                    </p>
                    <div className="flex justify-between items-center" data-id="element-3776">
                      <div className="flex items-center gap-1" data-id="element-3777">
                        <span className={`w-4 h-4 rounded-full bg-${getPersonalityColor(template.personality)}-100 dark:bg-${getPersonalityColor(template.personality)}-900/30 flex items-center justify-center text-${getPersonalityColor(template.personality)}-600 dark:text-${getPersonalityColor(template.personality)}-400 text-xs`} data-id="element-3778">
                          {personalities.find(p => p.id === template.personality)?.emoji}
                        </span>
                        <span className="text-xs text-gray-500 capitalize" data-id="element-3779">
                          {template.personality} mode
                        </span>
                      </div>
                      <div className="flex gap-1" data-id="element-3780">
                        <button className="px-2 py-1 bg-gray-200 dark:bg-gray-800 rounded text-xs" data-id="element-3781">
                          Edit
                        </button>
                        <button className="px-2 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded text-xs font-medium" data-id="element-3782">
                          Use
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>
              {/* AI Tease Generator */}
              <div className="mt-6 p-4 bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-lg border border-purple-100 dark:border-purple-800/30" data-id="element-3783">
                <div className="flex items-center gap-2 mb-4" data-id="element-3784">
                  <Sparkles className="w-5 h-5 text-purple-600 dark:text-purple-400" data-id="element-3785" />
                  <h4 className="font-medium" data-id="element-3786">AI Tease Generator</h4>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3787">
                  <div className="space-y-3" data-id="element-3788">
                    <div data-id="element-3789">
                      <label className="block text-sm font-medium mb-1" data-id="element-3790">
                        Content Type
                      </label>
                      <select className="w-full p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md text-sm" data-id="element-3791">
                        <option data-id="element-3792">Photo Tease</option>
                        <option data-id="element-3793">Video Announcement</option>
                        <option data-id="element-3794">Live Stream Invitation</option>
                        <option data-id="element-3795">Special Offer</option>
                        <option data-id="element-3796">Voice Message Promo</option>
                      </select>
                    </div>
                    <div data-id="element-3797">
                      <label className="block text-sm font-medium mb-1" data-id="element-3798">
                        Personality
                      </label>
                      <select className="w-full p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md text-sm" data-id="element-3799">
                        <option data-id="element-3800">Girlfriend Experience</option>
                        <option data-id="element-3801">Dominant Mistress</option>
                        <option data-id="element-3802">Innocent Tease</option>
                        <option data-id="element-3803">Cosplay Princess</option>
                        <option data-id="element-3804">Custom</option>
                      </select>
                    </div>
                    <div data-id="element-3805">
                      <label className="block text-sm font-medium mb-1" data-id="element-3806">
                        Include Emojis
                      </label>
                      <div className="flex gap-2" data-id="element-3807">
                        <button className="px-3 py-1.5 bg-pink-100 dark:bg-pink-900/30 text-pink-600 dark:text-pink-400 rounded-md text-sm flex items-center gap-1" data-id="element-3808">
                          <Heart className="w-4 h-4" data-id="element-3809" />
                          Flirty
                        </button>
                        <button className="px-3 py-1.5 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-md text-sm flex items-center gap-1" data-id="element-3810">
                          <span data-id="element-3811">🔥</span>
                          Spicy
                        </button>
                        <button className="px-3 py-1.5 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-md text-sm flex items-center gap-1" data-id="element-3812">
                          <span data-id="element-3813">💦</span>
                          Wet
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-3" data-id="element-3814">
                    <div data-id="element-3815">
                      <label className="block text-sm font-medium mb-1" data-id="element-3816">
                        Keywords (optional)
                      </label>
                      <input type="text" placeholder="lingerie, shower, new toy..." className="w-full p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md text-sm" data-id="element-3817" />
                    </div>
                    <div data-id="element-3818">
                      <label className="block text-sm font-medium mb-1" data-id="element-3819">
                        Call to Action
                      </label>
                      <select className="w-full p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md text-sm" data-id="element-3820">
                        <option data-id="element-3821">Subscribe to VIP</option>
                        <option data-id="element-3822">Buy Content</option>
                        <option data-id="element-3823">Schedule Call</option>
                        <option data-id="element-3824">Send Tip</option>
                        <option data-id="element-3825">Request Custom</option>
                      </select>
                    </div>
                    <div data-id="element-3826">
                      <label className="block text-sm font-medium mb-1" data-id="element-3827">
                        Media Attachment
                      </label>
                      <div className="flex gap-2" data-id="element-3828">
                        <button className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-md text-sm flex items-center gap-1" data-id="element-3829">
                          <Image className="w-4 h-4" data-id="element-3830" />
                          Photo
                        </button>
                        <button className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-md text-sm flex items-center gap-1" data-id="element-3831">
                          <Video className="w-4 h-4" data-id="element-3832" />
                          Video
                        </button>
                        <button className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-md text-sm flex items-center gap-1" data-id="element-3833">
                          <Gift className="w-4 h-4" data-id="element-3834" />
                          Gift
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <button className="w-full mt-4 py-2.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg text-sm font-medium flex items-center justify-center gap-2" data-id="element-3835">
                  <Sparkles className="w-4 h-4" data-id="element-3836" />
                  Generate AI Tease Message
                </button>
              </div>
            </div>}
        </div>
      </div>
      {/* Trigger Events */}
      <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3837">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2" data-id="element-3838">
          <Zap className="w-5 h-5 text-yellow-500" data-id="element-3839" />
          Trigger-Based Replies
        </h3>
        <div className="space-y-3" data-id="element-3840">
          <div className="p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-100 dark:border-yellow-800/30" data-id="element-3841">
            <div className="flex items-center justify-between mb-2" data-id="element-3842">
              <div className="flex items-center gap-2" data-id="element-3843">
                <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-3844"></div>
                <h5 className="font-medium text-sm" data-id="element-3845">User sends a photo</h5>
              </div>
              <div className="flex items-center gap-1" data-id="element-3846">
                <span className="text-xs bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 px-2 py-0.5 rounded-full" data-id="element-3847">
                  High converting
                </span>
                <div className="flex" data-id="element-3848">
                  <button className="p-1 hover:bg-yellow-100 dark:hover:bg-yellow-900/30 rounded-md" data-id="element-3849">
                    <Edit className="w-4 h-4 text-gray-500" data-id="element-3850" />
                  </button>
                  <button className="p-1 hover:bg-yellow-100 dark:hover:bg-yellow-900/30 rounded-md" data-id="element-3851">
                    <Settings className="w-4 h-4 text-gray-500" data-id="element-3852" />
                  </button>
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-3853">
              "That's sooo hot… 🔥 I can't stop looking at it. Wanna know what
              I'd do with it? Check your DMs in 5 minutes for a special
              surprise..."
            </p>
            <div className="flex justify-between items-center" data-id="element-3854">
              <div className="flex items-center gap-1" data-id="element-3855">
                <span className="text-xs text-gray-500" data-id="element-3856">
                  Auto-sends: <span className="text-green-500" data-id="element-3857">Enabled</span>
                </span>
              </div>
              <span className="text-xs px-2 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-full flex items-center gap-1" data-id="element-3858">
                <ArrowRight className="w-3 h-3" data-id="element-3859" />
                Leads to paid content
              </span>
            </div>
          </div>
          <div className="p-3 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-3860">
            <div className="flex items-center justify-between mb-2" data-id="element-3861">
              <div className="flex items-center gap-2" data-id="element-3862">
                <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-3863"></div>
                <h5 className="font-medium text-sm" data-id="element-3864">
                  User mentions being horny
                </h5>
              </div>
              <div className="flex" data-id="element-3865">
                <button className="p-1 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-md" data-id="element-3866">
                  <Edit className="w-4 h-4 text-gray-500" data-id="element-3867" />
                </button>
                <button className="p-1 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-md" data-id="element-3868">
                  <Settings className="w-4 h-4 text-gray-500" data-id="element-3869" />
                </button>
              </div>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-3870">
              "Mmm me too actually... 😏 I was just about to film something
              special. Want me to send you a preview when I'm done?"
            </p>
            <div className="flex justify-between items-center" data-id="element-3871">
              <div className="flex items-center gap-1" data-id="element-3872">
                <span className="text-xs text-gray-500" data-id="element-3873">
                  Auto-sends: <span className="text-green-500" data-id="element-3874">Enabled</span>
                </span>
              </div>
              <span className="text-xs px-2 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-full flex items-center gap-1" data-id="element-3875">
                <ArrowRight className="w-3 h-3" data-id="element-3876" />
                Leads to paid content
              </span>
            </div>
          </div>
          <div className="p-3 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-3877">
            <div className="flex items-center justify-between mb-2" data-id="element-3878">
              <div className="flex items-center gap-2" data-id="element-3879">
                <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-3880"></div>
                <h5 className="font-medium text-sm" data-id="element-3881">
                  User asks for free content
                </h5>
              </div>
              <div className="flex" data-id="element-3882">
                <button className="p-1 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-md" data-id="element-3883">
                  <Edit className="w-4 h-4 text-gray-500" data-id="element-3884" />
                </button>
                <button className="p-1 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-md" data-id="element-3885">
                  <Settings className="w-4 h-4 text-gray-500" data-id="element-3886" />
                </button>
              </div>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-3887">
              "I'd love to share more with you! I actually have a special deal
              right now - 50% off your first month as a VIP. You'll get access
              to all my exclusive content plus private messaging. Want to try
              it?"
            </p>
            <div className="flex justify-between items-center" data-id="element-3888">
              <div className="flex items-center gap-1" data-id="element-3889">
                <span className="text-xs text-gray-500" data-id="element-3890">
                  Auto-sends: <span className="text-green-500" data-id="element-3891">Enabled</span>
                </span>
              </div>
              <span className="text-xs px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full flex items-center gap-1" data-id="element-3892">
                <ArrowRight className="w-3 h-3" data-id="element-3893" />
                Leads to subscription
              </span>
            </div>
          </div>
        </div>
        <div className="mt-4" data-id="element-3894">
          <button className="w-full py-2 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 rounded-lg text-sm font-medium flex items-center justify-center gap-2" data-id="element-3895">
            <Plus className="w-4 h-4" data-id="element-3896" />
            Add New Trigger
          </button>
        </div>
      </div>
    </div>;
}